import { useQuery } from '@tanstack/react-query';

import { createCalenderEvents } from '../../Repositories';

const calendarEventsReq = createCalenderEvents();

/**
 * this function(query) is to get all events of calendar
 * @function useCalendarEventsGetQuery
 * @param {Object} reqParams params pass along with the api call
 * @param {Object} options to be passed as query handling
 * @returns api response
 */
export function useCalendarEventsGetQuery(reqParams, options) {
  return useQuery(
    ['calendarEventsGetQuery', reqParams],
    () => calendarEventsReq.getAllEvents(reqParams),
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      ...options,
    }
  );
}

/**
 * @function useCalendarGetQuery
 *
 */

export function useCalendarGetQuery(options) {
  return useQuery(['calendarGetQuery'], () => calendarEventsReq.getAllCalendars(), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    ...options,
  });
}

/**
 * @description function to fetch events by user id
 */

export function useCalendarEventsByUserIdGetQuery(reqParams, options) {
  return useQuery(
    ['CalendarEventsByUserIdGetQuery', reqParams],
    () => calendarEventsReq.getEventsByUserID(reqParams),
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      ...options,
    }
  );
}
